// extracted by mini-css-extract-plugin
export var brand = "_a5-9";
export var compact = "_a5-6";
export var extraSmall = "_a5-7";
export var icon = "_a5-0";
export var large = "_a5-4";
export var light = "_a5-1";
export var medium = "_a5-5";
export var outline = "_a5-b";
export var primaryDark = "_a5-a";
export var primaryLight = "_a5-8";
export var primaryModern = "_a5-c";
export var success = "_a5-2";
export var successSolid = "_a5-3";